let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jDtf9")).then(() => parcelRequire('9rDEK'));